{
  "filterFields": [
    {
      "name": "name",
      "displayLabel": "Name",
      "dataType": "STRING",
      "operatorToFilterMap": {
        "EQ": "NAME_EQUALS",
        "CONTAINS": "NAME_CONTAINS"
      }
    },
    {
      "name": "email",
      "displayLabel": "Email",
      "dataType": "STRING",
      "operatorToFilterMap": {
        "EQ": "EMAIL_EQUALS",
        "CONTAINS": "EMAIL_CONTAINS"
      }
    },
    {
      "name": "mobile",
      "displayLabel": "Mobile",
      "dataType": "STRING",
      "operatorToFilterMap": {
        "EQ": "MOBILE_EQUALS"
      }
    },
    {
      "name": "isActive",
      "displayLabel": "Active",
      "dataType": "CHECKBOX",
      "operatorToFilterMap": {
        "EQ": "IS_ACTIVE"
      }
    }
  ]
}
